import React, {useState} from 'react';
import Button from 'react-bootstrap/Button';
import {postApiSystemDbDataClear, postApiSystemDbFactoryReset} from '../../common/fetch_api/api_common.js';
import {LoadingSpinner} from '../../common/component_common.js';
import {DecideWindow} from '../../common/modal_common.js';

export const View = () =>
{
    const [loading, setLoading] = useState(false);

    const [modalClear, setModalClear] = useState(false);
    const [modalReset, setModalReset] = useState(false);
    const closeModalClear = () => setModalClear(false);
    const closeModalReset = () => setModalReset(false);
    const [decideBtn, setDecideBtn] = useState('OK');
    const [decideBody, setDecideBody] = useState(null);

    const [type, setType] = useState('users');

    const onChangeTableData = (e) =>
    {
        setType(e.target.value);
    }

    const onClickClear = (result) =>
    {
        if(result)
        {
            setLoading(true);

            Promise.resolve( postApiSystemDbDataClear(type) )
            .then( done => {
                setLoading(false);
            });
        }
    }

    const onClickReset = (result) =>
    {
        if(result)
        {
            setLoading(true);
    
            Promise.resolve( postApiSystemDbFactoryReset() )
            .then( done => {
                setLoading(false);
            });
        }
    }

    const showModalClear = () =>
    {
        setDecideBtn('Delete');
        setDecideBody(
            <div className='text-center'>
                <p>Would you like to clear this Database?</p>
            </div>
        );
        
        setModalClear(true);
    }

    // const showModalReset = () =>
    // {
    //     setDecideBtn('Reset');
    //     setDecideBody(
    //         <div className='text-center'>
    //             <p>`Would you like to Factory Reset?`</p>
    //         </div>
    //     );
        
    //     setModalReset(true);
    // }

    return (
        <>
        <div className="tab-pane show active">
            <div className="section control-system-area">
                <div className="alert-area">
                    <div className="section-title mt-3">Database</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">Table Data</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                            <select className="form-select form-select-sm" value={type} onChange={onChangeTableData}>
                                <option value='users'>users</option>
                                <option value='token'>token</option>
                                <option value='site'>site</option>
                                <option value='edge'>edge</option>
                                <option value='alert_rules'>alert_rules</option>
                                <option value='alert_status'>alert_status</option>
                                <option value='edge_history'>edge_history</option>
                                <option value='site_history'>site_history</option>
                            </select>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                            <Button variant="primary" className="btn btn-sm ms-2" onClick={showModalClear}>Clear</Button>
                        </div>
                    </div>
                </div>
                {/* <div className="d-flex my-2">
                    <Button variant="danger" className="btn btn-sm" onClick={showModalReset}>Factory Reset</Button>
                </div> */}
            </div>
        </div>
        {modalClear&&<DecideWindow result={onClickClear} show={modalClear} handleClose={closeModalClear} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
        {modalReset&&<DecideWindow result={onClickReset} show={modalReset} handleClose={closeModalReset} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
        <LoadingSpinner loading={loading}/>
        </>
    )
}